<div class="card-container">
  <div class="heading-container">
    <rt-icon
      class="main-icon"
      [name]="iconName"
      size="large"
      colorToken="colorIconPrimaryDefault"
      [hasAutoHeight]="true"
    />
    <div>
      <span class="product-name">{{ productName }}</span
      >&nbsp;
      @if (productType) {
        <span class="product-type">{{ productType }}</span>
      }
    </div>
  </div>
  <span class="text">{{ text }}</span>
  @if (isActive) {
    <div class="check-wrapper">
      <rt-icon name="check" size="small-x" colorToken="colorIconOnprimaryDefault" />
    </div>
  }
</div>
